import { render, staticRenderFns } from "./VaSocialNews.vue?vue&type=template&id=749eb894&"
import script from "./VaSocialNews.vue?vue&type=script&lang=js&"
export * from "./VaSocialNews.vue?vue&type=script&lang=js&"
import style0 from "./VaSocialNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports